import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { InsuranceService } from '../_services/insurance.services';
import { DocumentService } from '../_services/document.services';
import { InterestService } from '../_services/interest.services';
import { HelperServices } from '../_services/helper.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { Interest } from '../_models/interest.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

import {
    GroupingState,
    PaginatorState,
    SortState,
    ICreateAction,
    IEditAction,
    IDeleteAction,
    IDeleteSelectedAction,
    IFetchSelectedAction,
    IUpdateStatusForSelectedAction,
    ISortView,
    IFilterView,
    IGroupingView,
    ISearchView,
  } from '../../_metronic/shared/crud-table';

@Component({
  selector: 'app-list-documents',
  templateUrl: './list-documents.component.html',
  styleUrls: ['./list-documents.component.scss']
})
export class ListDocumentsComponent implements 
OnInit, 
OnDestroy {
	private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	loadingModalConfig: NgbModalOptions = {
		backdrop : 'static',
		keyboard : false
	};
	loadingModal: boolean = false;

	paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
	templateView: number = 0;
	uplodaTypedocument: number = 0;
	document_selected: Document;
	permissionMenu: any;
	extrasUserDropdownStyle: 'light' | 'dark' = 'light';
	user$: Observable<UserModel>;
	_user: UserModel;
	
	constructor(
		public insuranceService: InsuranceService,
		public documentService: DocumentService,
		public interestService: InterestService,
		private layout: LayoutService,
		private auth: AuthService,
		private fb: FormBuilder,
		private modalService: NgbModal,
		private modalLoading: NgbModal,
		public sanitizer: DomSanitizer,
		public helperServices: HelperServices
	) {}

	// angular lifecircle hooks
	ngOnInit(): void {
		this.initForm();

		this.extrasUserDropdownStyle = this.layout.getProp(
		'extras.user.dropdown.style'
		);
		this.user$ = this.auth.currentUserSubject.asObservable();
		this.user$.subscribe(user => {
		    this._user = user;
            this.templateView = 1;
		});

		this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
	}

	ngOnDestroy() {
		//this.subscriptions.forEach((sb) => sb.unsubscribe());
	}

	initForm() {

	}

	clickView(id = 0, _templateView) {
		if(!id){
		return false;
		}
		else {
		switch ((this.templateView = _templateView)) {
			case 1:
			this.templateView = _templateView;
			break;
			case 2:
			this.templateView = _templateView;
			break;
			case 3:
			this.templateView = _templateView;
			break;
		}
		} 
	}

	changeUploadTypeDocument(event) {
		this.uplodaTypedocument = event.target.value;
	}
}
